import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "create-form"
}
const _hoisted_2 = ["validation-schema"]
const _hoisted_3 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Guild name", -1)
const _hoisted_5 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_6 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1)
const _hoisted_8 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_9 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "isPrivate" }, "Is this a private server?", -1)
const _hoisted_11 = { class: "cta-section flex flex-row gap-3 justify-content-end" }
const _hoisted_12 = {
  key: 1,
  class: "post_guild-pending"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Creating guild...", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "post_guildd"
}
const _hoisted_16 = { class: "flex justify-content-end" }

import { watch } from 'vue';
import { useGuildStore } from '@/stores/GuildStore';
import { useApiStatusStore } from '@/stores/ApiStatusStore';
import { useDialogStore } from '@/stores/DialogStore';
import { useForm, configure } from 'vee-validate';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import Button from 'primevue/button';
import * as yup from 'yup';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildCreate',
  setup(__props) {

const guildStore = useGuildStore();
const apiStatusStore = useApiStatusStore();

const schema = yup.object({
  name: yup.string().min(4).required(),
  description: yup.string(),
  isPrivate: yup.boolean(),
});

const { defineField, handleSubmit, errors } = useForm({
  validationSchema: schema,
});

const [name] = defineField('name');
const [description] = defineField('description');
const [isPrivate] = defineField('isPrivate');

configure({
  validateOnBlur: true,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false
})

const onSubmit = handleSubmit((values: any) => {
  guildStore.createGuild(values);
});

watch(() => apiStatusStore.requestFulfilled('post_guild'), (newValue) => {
  if (newValue) {
    useDialogStore().changeHeader('Guild succesfully created')
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(apiStatusStore).requests.get('post_guild'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"])),
            "validation-schema": _unref(schema)
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(InputText), {
                modelValue: _unref(name),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                id: "name",
                type: "name",
                class: _normalizeClass({ 'p-invalid': _unref(errors).name })
              }, null, 8, ["modelValue", "class"]),
              _createElementVNode("small", _hoisted_5, _toDisplayString(_unref(errors).name), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_unref(InputText), {
                modelValue: _unref(description),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(description) ? (description).value = $event : null)),
                id: "description",
                type: "description",
                class: _normalizeClass({ 'p-invalid': _unref(errors).description })
              }, null, 8, ["modelValue", "class"]),
              _createElementVNode("small", _hoisted_8, _toDisplayString(_unref(errors).description), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_unref(Checkbox), {
                modelValue: _unref(isPrivate),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isPrivate) ? (isPrivate).value = $event : null)),
                id: "isPrivate",
                value: false,
                binary: "",
                class: _normalizeClass({ 'p-invalid': _unref(errors).isPrivate })
              }, null, 8, ["modelValue", "class"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(Button), {
                label: "Cancel",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                label: "Create",
                disabled: _unref(apiStatusStore).requestPending('post_guild')
              }, null, 8, ["disabled"])
            ])
          ], 40, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestPending('post_guild'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestFulfilled('post_guild'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_unref(Button), {
              label: "Close",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})